package com.fireavert.properties.shared.data_models

import com.fireavert.devices.data_models.data_model.DeviceType

data class Property(
    val id: Int = 0,
    val name: String = "",
    val units: Int = 0,
    val address: String = "",
    val city: String = "",
    val state: String = "",
    val zip: String = "",
    val managementCompany: String = "",
    val managementCompanyId: Int = 0,
    val subscriptionType: SubscriptionType = SubscriptionType.Standard,
    val mode: Mode = Mode.Test,
    val propertyType: PropertyType = PropertyType.MultiFamily,
    val timezoneId: String = "",
    val propertyClass: PropertyClass = PropertyClass.UNKNOWN,
    val startDate: String = "",
    val pmsType: PmsType = PmsType.None,
    val defaultStoveCookingTimeMinutes: Int = 40,
    val overrideUnitCookingTimes: Boolean = false,
    val hasDeviceTypes: Set<DeviceType> = emptySet(),
)

